import * as React from "react";
import { NextPageContext } from "next";

import { GenomesListPage } from "../../components/pages/genomes";
import { DarwinPageContext, isServer } from "../_app";
import { NextSeo } from "next-seo";

const GenomesIndex = () => {
  return (
    <>
      <NextSeo title="Bacteriology Genomes" description="Bacteriology Genomes Description" />
      <GenomesListPage collectionName="bacteriology" />
    </>
  );
};

GenomesIndex.getInitialProps = async (ctx: NextPageContext & DarwinPageContext) => {
  ctx.rootStore.genomesStoreType = "genomes-page";

  if (!isServer) {
    return {};
  }

  ctx.rootStore.genomeStore.setVariablesFromQuery(ctx.query);
  ctx.rootStore.genomeStore.setCollectionName("bacteriology");
  await ctx.rootStore.genomeStore.fetchGenomes();
  ctx.rootStore.genomeStore.hydrated = true;
  return {};
};

export default GenomesIndex;
